export default [
    {
        title: "Shoonya bets on Artificial Intellige for trading",
        description:`<strong>NEW DELHI:</strong> Shoonya by Finvasia, the leading zero-brokerage trading platform on Wednesday announced that it is India’s first trading platform to offer AI-based predictions and signals for individual stocks. It has partnered with I Know First (IKF), a financial technology firm specializing....`,
        date: "May 17, 2023,",
        link: "https://timesofindia.indiatimes.com/business/startups/companies/shoonya-bets-on-artificial-intelligence-for-trading/articleshow/100298613.cms?from=mdr",
        img: "shoonyanewpr1.webp",
    },
    {
        title: "Shoonya pays compensation totalling Rs 3 crore to traders after tech glitch",
        description:`From our last analysis as of 27 April 2023, we have received just below 700 disputes about the said incident, and 12% of these were duplicates. From the remaining disputes, only 77.5% were eligible for compensation and we have been able to resolve around 77% of these eligible cases,” said Finvasia co-founders <a href='https://economictimes.indiatimes.com/topic/sarvjeet-virk' class='links-theme' target='_blank'>Sarvjeet Virk</a> and <a href='https://economictimes.indiatimes.com/topic/tajinder-virk' class='links-theme' target='_blank'>Tajinder Virk</a>....`,
        date: "May 01, 2023,",
        link: "https://economictimes.indiatimes.com/markets/expert-view/shoonya-pays-compensation-totalling-rs-3-crore-to-traders-after-tech-glitch/articleshow/99902817.cms?from=mdr",
        img: "tajindervirk-sarvjeetvirk.webp",
    },
    {
        title: "Finvasia-owned Shoonya broker issues clarification on tech glitch",
        description:"After traders complained of bogus orders and massive losses following a tech glitch, Finvasia-run zero-broking platform <a href='https://economictimes.indiatimes.com/topic/shoonya' class='links-theme' target='_blank'>Shoonya</a> has clarified that the issue was only with the front end and not at the back end.",
        date: "Apr 14, 2023,",
        link: "https://economictimes.indiatimes.com/markets/stocks/news/finvasia-owned-shoonya-broker-issues-clarification-on-tech-glitch/articleshow/99491865.cms?from=mdr",
        img: "",
    },
    {
        title: "Zero-broking platform Finvasia hit by tech glitch, traders suffer losses",
        description:"NEW DELHI: Traders using zero-broking platform <a class='links-theme' target='_blank' href='https://economictimes.indiatimes.com/topic/finvasia'>Finvasia</a> suffered losses today as a technical glitch barred them from squaring off existing positions....",
        date: "Apr 13, 2023,",
        link: "https://economictimes.indiatimes.com/markets/stocks/news/zero-broking-platform-finvasia-hit-by-tech-glitch-traders-suffer-losses/articleshow/99462402.cms",
        img: "",
    },
    {
        title: "The Finvasia Group launches the All-New Shoonya",
        description:`Mohali (Punjab) [India], December 9 (ANI/BusinessWire India): The Finvasia group today announced the transition of Shoonya–their Zero Commission...`,
        date: "December 09, 2022",
        link: "https://theprint.in/ani-press-releases/the-finvasia-group-launches-the-all-new-shoonya/1257683/",
        img: "",
    },
    {
        title: "Finvasia Group opens a new office in India's Financial Capital, Mumbai",
        description:"Mumbai (Maharashtra) [India], November 22 (ANI/BusinessWire India): Finvasia Group today announced the opening of its new office in India's Financial Capital, Mumbai. With some significant acquisitions like Fxview (Cyprus-based financial services provider), Gini Health (healthcare services company), and major investment platforms ZuluTrade and ACT Trader already under Finvasia's cap,",
        date: "Nov 22, 2022",
        link: "https://www.aninews.in/news/business/business/finvasia-group-opens-a-new-office-in-indias-financial-capital-mumbai20221122104050/",
        img: "ANI-20221122050926.jpg",
    },
    // {
    //   title:
    //     "AAAFx Set to Unveil Zero Commission ECN Plus Account at the iFX EXPO International 2022",
    //   description:
    //     "The Pioneering Greek brokerage, AAAFx looks set to revamp its product offerings as part of their mission to continue delivering quality services to their expanding clientele. The international broker will also be offering lower commissions fees for indices, commodities, and stocks. This will be made possible thanks to the new ECN Plus account system that AAAFx will be offering.",
    //   date: "june 8, 2022",
    //   link: "https://www.fxempire.com/news/article/aaafx-set-to-unveil-zero-commission-ecn-plus-account-at-the-ifx-expo-international-2022-1026760",
    //   img: "aaafx.webp",
    // },
    {
        title: "Finvasia’s Expansion into Europe",
        description:"Finvasia has targeted massive expansion into Europe as the lynchpin of its plans to muscle further into the international market. The company plans to use its size and expertise in the financial services, technology, real estate and healthcare sectors to build a pan-European presence.",
        date: "june 7, 2022",
        link: "https://www.forexlive.com/Education/finvasias-expansion-into-europe-20220607/",
        img: "finvasia_id.webp",
    },
    // {
    //   title:
    //     "Senior Leadership Changes at Fxview Announced for Long-Term Success",
    //   description:
    //     "Leading fintech conglomerate, Finvasia Group, has made senior leadership changes at Fxview, in preparation for a significant European expansion. Having acquired the leading, Cyprus-based forex brokerage back in June 2021, Finvasia is now taking a more active business management role in a bid to secure future growth, while continuing to deliver for both clients and stakeholders.",
    //   date: "june 6, 2022",
    //   link: "https://www.financemagnates.com/thought-leadership/senior-leadership-changes-at-fxview-announced-for-long-term-success/",
    //   img: "fxview_id.webp",
    // },
    // {
    //     title:
    //         "Finvasia names own chief executive tajinder virk as interim ceo for zulutrade",
    //     description:
    //         "Finvasia has appointed Tajinder Virk as the interim Chief Executive Officer for ZuluTrade, one of the first social trading platforms ever. The copy trading fintech launched in 2008 was acquired by Finvasia in 2021.",
    //     date: "April 19, 2022",
    //     link: "https://financefeeds.com/finvasia-names-chief-executive-tajinder-virk-interim-ceo-zulutrade/",
    //     img: "ZuluTrade-300x223.png",
    // },
    // {
    //   title:
    //     "ZuluTrade Eyes Expansion in 2022, Seeks More Regulatory Licenses",
    //   description:
    //     "ZuluTrade, which was acquired by Finvasia last month, revealed on Friday that it is planning for expansion this year and adding new capabilities to its existing social trading platform.",
    //   date: "January 21, 2022",
    //   link: "https://www.financemagnates.com/forex/products/zulutrade-eyes-expansion-in-2022-seeks-more-regulatory-licenses/",
    //   img: "zulu-header.webp",
    // },
    {
        title: "Finvasia acquires major social trading platform, Zulutrade",
        description:"Finvasia Group has announced a major acquisition as it expands further across the globe and into the retail FX space. Zulu Trade Group, one of the world’s largest and oldest social network for trading and investing, is now part of the Finvasia group of companies.",
        date: "December 14, 2021",
        link: "https://financefeeds.com/finvasia-acquires-major-social-trading-platform-zulutrade",
        img: "ZuluTrade-300x223.png",
    },
    // {
    //   title:
    //     "ActTrader voted as the ‘The Best Multi-Asset Platform’ at The Forex Expo, Dubai 2021",
    //   description:
    //     "Finvasia Group has announced a major acquisition as it expands further across the globe and into the retail FX space. Zulu Trade Group, one of the world’s largest and oldest social network for trading and investing, is now part of the Finvasia group of companies.",
    //   date: "November 2, 2021",
    //   link: "https://finance.yahoo.com/news/acttrader-voted-best-multi-asset-095600064.html",
    //   img: "dubai_1.webp",
    // },
    // {
    //   title:
    //     "Fxview Crowned as the Best Value Broker at the Forex Expo Dubai, 2021",
    //   description:
    //     'Fxview, a leading financial services company owned by Finvasia Group, won the award for "Best Value Broker" at the Forex Expo Dubai 2021. This award acknowledges the company’s efforts to provide retail clients with the trading conditions that only institutional clients had access to.',
    //   date: "November 2, 2021",
    //   link: "https://finance.yahoo.com/news/fxview-crowned-best-value-broker-090400323.html",
    //   img: "dubai_2.webp",
    // },
    {
        title:"FINVASIA Acquires Gini Health, Expands Into Healthcare Services",
        description:"FINVASIA, announced its investment in Gini Health, a Canada based healthcare technology company that pioneered DNA and lifestyle data based personalized health to prevent diseases.",
        date: "November 1, 2021",
        link: "https://aithority.com/medical-apps/healthcare-management/finvasia-acquires-gini-health-expands-into-healthcare-services/",
        img: "FINVASIA_Acquires_Gini_Health.webp",
    },
    // {
    //   title:
    //     "ACTTRADER CEO ILYA SOROKIN TALKS ARTIFICIAL INTELLIGENCE IN TRADING, CRYPTO BOOM",
    //   description:
    //     "New York-based financial technology solutions provider ActTrader Technologies has made the headlines over the past few months. Most recently, it was acquired by India-based, Multi-disciplinary and Multi-national organisation Finvasia Group.",
    //   date: "OCTOBER 20, 2021",
    //   link: "https://financefeeds.com/ifx-expo-2021-acttrader-ceo-ilya-sorokin-talks-artificial-intelligence-trading-crypto-boom/",
    //   img: "ACTTRADER_CEO_ILYA_SOROKIN_TALKS.webp",
    // },
    // {
    //   title:
    //     "FXVIEW AT THE IFX EXPO: ZERO-COST TRADING AND THE WHITE LABEL SOLUTION",
    //   description:
    //     "FinanceFeeds went to Limassol, Cyprus to meet the industry leaders. A key highlight was the interview with Daniela Egli, Managing Director of Fxview. The retail FX and CFD broker has recently made the headlines in June when it announced it was acquired by Finvasia Group, a fintech giant known for offering zero commission (brokerage fees, clearing fees) “forever”.",
    //   date: "OCTOBER 19, 2021",
    //   link: "https://financefeeds.com/fxview-ifx-expo-zero-cost-trading-white-label-solution/",
    //   img: "FXVIEW_AT_THE_IFX_EXPO.webp",
    // },
    // {
    //   title:
    //     "Gini Health Debuts Into Chronic Health Care Management, Launches Diabetes Reversal Program",
    //   description:
    //     "Gini Health, one of North America's fastest growing health-tech companies, has teamed up with world-class doctors to launch a type 2 diabetes reversal program. Riding on the success of its pilot 12-week diabetes reversal program.",
    //   date: "OCTOBER 1, 2021",
    //   link: "https://finance.yahoo.com/news/gini-health-debuts-chronic-health-095600745.html",
    //   img: "Gini_Health.webp",
    // },
    // {
    //     title: "FINVASIA Group Announces Acquisition of ActTrader",
    //     description:
    //         "FINVASIA Group announced today that it has acquired ActTrader Technologies (formerly ActForex)...",
    //     date: "19 July, 2021",
    //     link: "https://www.bloomberg.com/press-releases/2021-07-19/finvasia-group-announces-acquisition-of-acttrader",
    //     img: "actTrader.webp",
    // },
    // {
    //   title:
    //     "FINANCIAL COMMISSION APPROVES FXVIEW: PROTECTION OF UP TO €20,000 PER COMPLAINT",
    //   description:
    //     "The Financial Commission, an independent external dispute resolution (EDR) organization for consumers/traders, has announced Fxview as its newest approved Member. Fxview was recently acquired by Finvasia Group which could reinforce the broker’s low-cost model.",
    //   date: "JULY 7, 2021",
    //   link: "https://financefeeds.com/financial-commission-approves-fxview-protection-of-up-to-e20000-per-complaint/",
    //   img: "FINANCIAL_COMMISSION_APPROVES_FXVIEW.webp",
    // },

    // {
    //   title:
    //     "Fxview Expands Operations with a Subsidiary in Saint Vincent and Grenadines",
    //   description:
    //     "Fxview, a Cyprus-based financial services provider, announced today that it has established an offshore subsidiary in Saint Vincent and Grenadines to expand the company’s operations. According to the official press release, Charlgate SVG LLC will ensure the expansion of products and services on Fxview’s platforms.",
    //   date: "June 21,  2021",
    //   link: "https://www.financemagnates.com/forex/brokers/fxview-expands-operations-with-a-subsidiary-in-saint-vincent-and-grenadines/",
    //   img: "Fxview_Expands_Operations.webp",
    // },
    // {
    // 	'title': 'FINVASIA GROUP ACQUIRES FCA AND CYSEC-REGULATED BROKER FXVIEW',
    // 	'description' : 'The acquisition could reinforce Fxview’s low-cost model as Finvasia is known to offer zero commission (brokerage fees, clearing fees) “forever” on its offering, including stocks, ETFs, bonds, mutual funds...',
    // 	'date' : '16 JUN 2021',
    // 	'link' : 'https://financefeeds.com/finvasia-group-acquires-fca-cysec-regulated-broker-fxview/',
    // 	'img' : '="fxviewlogo_b.webp'
    // },
    // {
    // 	'title': 'CFD broker Fxview acquired by Finvasia Group',
    // 	'description' : 'Finvasia Group has recently announced its acquisition of Fxview, a Cyprus-based CFD broker and financial services provider with clients in more than 25 countries around the globe...',
    // 	'date' : '16 JUN  2021',
    // 	'link' : 'https://www.leaprate.com/forex/institutional/cfd-broker-fxview-acquired-by-finvasia-group/',
    // 	'img' : '="acquisition.webp'
    // },
    {
        title: "Finvasia Group Acquires Fxview, a Leader in FX and CFDs",
        description:"Finvasia Group, which operates multiple brands in the FinTech industry today announced that it acquired Cyprus-based financial services company, Fxview. FINVASIA Group has acquired 100% stake in the company for an undisclosed sum.",
        date: "June 15, 2021 ",
        link: "https://www.bloomberg.com/press-releases/2021-06-15/finvasia-group-acquires-fxview-a-leader-in-fx-and-cfds",
        img: "Finvasia_Group_Acquires_Fxview.webp",
    },
    // {
    // 	'title': 'Finvasia Group Announces Acquisition of Fxview',
    // 	'description' : 'The Group has acquired a 100% stake in the financial services provider for an undisclosed sum...',
    // 	'date' : '15 JUN 2021',
    // 	'link' : 'https://www.financemagnates.com/forex/brokers/finvasia-group-announces-acquisition-of-fxview/',
    // 	'img' : '="merger-and-acquisition.webp'
    // },

    // {
    //     title: "Finvasia gets licence to operate as NBFC",
    //     description:
    //         "Chandigarh-based Finvasia, a fintech company offering zero brokerage, has received the Certificate of Registration (CoR) from RBI to operate as a non-banking financial corporation (NBFC)...",
    //     date: "19 December 2020",
    //     link: "https://www.tribuneindia.com/news/archive/business/finvasia-gets-licence-to-operate-as-nbfc-515809",
    //     img: "",
    // },
    {
        title:"Finvasia Stock Broker has released their new trading platform.",
        description:"Finvasia is a stock broker in India with a zero brokerage model for day trading and investing across all instruments...",
        date: "27 November 2020",
        link: "https://stocksonfire.in/trading-tools-and-reviews/finvasia-stock-broker-released-new-trading-platform/",
        img: "",
    },
    // {
    //   title:
    //     "Fxview.com Takes a Spot Amongst the Top 75,000 Websites in the World",
    //   description:
    //     "Fxview.com, a leading FX and CFD provider, has reached a prestigious milestone by securing a spot in the world’s top 75,000 websites according to Alexa. The milestone was reached in less than 2 months after Charlgate Ltd relaunched its retail focused services on fxview.com...",
    //   date: "November 16, 2020",
    //   link: "https://finance.yahoo.com/news/fxview-com-takes-spot-amongst-093400765.html ",
    //   img: "Fxview.com.webp",
    // },
    // {
    //   title:
    //     "Charlgate Acquires fxview.com Domain, Launches Retail Trading",
    //   description:
    //     "Charlgate Ltd announced today that it has acquired the fxview.com domain name. According to the statement released, fxview.com has been around for three decades, and Charlgate has acquired the domain for an undisclosed sum...",
    //   date: "July 7, 2020",
    //   link: "https://www.financemagnates.com/forex/charlgate-acquires-fxview-com-domain-launches-retail-trading/",
    //   img: "Charlgate_Acquires_fxview.com.webp",
    // },
    {
        title:"Finvasia Ventures into real estate, launches its first project",
        description:"The project is a 8-storey commercial building spanning across 100,000 sq. ft. in Sector 74, Mohali, Punjab and is available for leasing to IT and ITES companies...",
        date: "04 JUN 2020",
        link: "https://www.hindustantimes.com/brand-post/finvasia-ventures-into-real-estate-launches-its-first-project/story-SlUqsl4Pt17hrqB0ObEasI.html",
        img: "finvasia_ventures.webp",
    },
    {
        title: "Finvasia Exits Its Proprietary Trading Service",
        description:"Finvasia voluntarily applied to NSE, BSE, MCX and NCDEX to close its proprietary trading account and has received approval for the same...",
        date: "03 April 2020",
        link: "https://www.theweek.in/wire-updates/business/2019/12/03/pwr28-finvasia.html",
        img: "",
    },
    {
        title: "Time to shift to renewable energy sources: CII chairman",
        description:"It is time for gradual transition from traditional to renewable energy sources, said Confederation of Indian Industry (CII) chairman, Sarvjeet Singh Virk...",
        date: "15 January 2020",
        link: "https://www.hindustantimes.com/chandigarh/time-to-shift-to-renewable-energy-sources-cii-chairman/story-QtlspIQzotNk4kTrgkUVZP.html",
        img: "time_to_shift.webp",
    },
    {
        title: "Exploring the ABCD for Starting Up",
        description:"The Vice Chairman of CII Chandigarh Council, Sarvjeet Singh Virk, shares how start-ups can add value to their valuation & why validating the idea before going for funding has become a necessity today....",
        date: "30 July 2019",
        link: "https://www.entrepreneur.com/article/337366",
        img: "exploring_the_abcd.webp",
    },
    {
        title: "Finvasia expects to open 10 million accounts by 2020: MD and co-founder Sarvjeet Singh Virk ",
        description:"While zero brokerage has already caught on with equity and mutual funds transactions, there are companies like Finvasia Securities that have just commenced...",
        date: "30 May 2019",
        link: "https://www.freepressjournal.in/business/finvasia-expects-to-open-10-million-accounts-by-2020-md-and-co-founder-sarvjeet-singh-virk",
        img: "Sarvjeet-Singh-Virk.webp",
    },
    {
        title: "How Discount Brokers are Disrupting the Stockbroking Industry",
        description:"Last month, when Zerodha replaced long-time market leader ICICI Securities as the country's largest stockbroker with 8.47 lakh clients, it surprised many in the industry,....",
        date: "MAR 5, 2019",
        link: "https://www.entrepreneur.com/en-in/finance/the-new-age-of-stockbroking-is-here-all-that-you-need-to/329570",
        img: "shoonyanewspr1.webp",
    },
    // {
    //   title: "VIRK ELECTED CHAIRMAN OF CII",
    //   description:
    //     "Chandigarh, Feb. 27 -- Sarvjeet Singh Virk and Dr SPS Grewal were respectively elected as the chairman and vicechairman of the Confederation of Indian Industry (CII), Chandigarh, for 2019-20 on Monday....",
    //   date: "27 February 2019",
    //   link: "https://www.htsyndication.com/ht-chandigarh/article/virk-elected-chairman-of-cii/33149729",
    //   img: "",
    // },

    {
        title:"Finvasia Approved to Transfer Commodity Membership in Capital Market",
        description:"(Eds: Disclaimer: The following press release comes to you under an arrangement with Business Wire India. PTI takes...",
        date: "22 October 2018",
        link: "https://www.businesstoday.in/pti-feed/story/finvasia-approved-to-transfer-commodity-membership-in-capital-market-150925-2018-10-22",
        img: "shoonyaoldpr1.png",
    },
    {
        title:"Finvasia – How a Leading Fintech in India Killed the Brokerage Industry",
        description:"The retail brokerage space continues to see a shakeup, spurred by a shifting regulatory space and a pursuit of new technologies...",
        date: "26 July 2018",
        link: "https://www.financemagnates.com/thought-leadership/finvasia-how-a-leading-fintech-in-india-killed-the-brokerage-industry/",
        img: "",
    },
    {
        title: "Finvasia gets licence to operate as NBFC",
        description:"CHANDIGARH: Chandigarh-based Finvasia, a fintech company offering zero brokerage, has received the Certificate of Registration (CoR) from RBI to operate as a non-banking financial corporation (NBFC).",
        date: "Dec 20, 2017 ",
        link: "https://www.tribuneindia.com/news/archive/business/finvasia-gets-licence-to-operate-as-nbfc-515809",
        img: "",
    },
    // {
    //   title:
    //     "Finvasia Unveils PRISM for Traders to Monitor and Analyze their Investment Portfolios",
    //   description:
    //     "Chandigarh, India:  FINVASIA today announced the launch of their one stop in-house custom client portal - PRISM. The client portal allows...",
    //   date: "23 October 2017",
    //   link: "https://www.businesswireindia.com/finvasia-unveils-prism-for-traders-to-monitor-and-analyze-their-investment-portfolios-55465.html",
    //   img: "",
    // },
    {
        title:"These Brothers are using AI to Kill the Brokerage Model in Capital Market ",
        description:"Capital market is a tricky place, where many have burnt their fingers and lost their hard earned money. The reasons are many and range from lack of knowledge...",
        date: "15 September 2017",
        link: "https://www.entrepreneur.com/article/300410",
        img: "",
    },
    {
        title:"Two brothers from Chandigarh are making Finvasia a one-stop shop for various funds",
        description:"Sarvjeet Singh Virk (37) and Tajinder Singh Virk (36), brothers from Chandigarh, founded Finvasia – a fintech firm that offers a wide range of...",
        date: "21 August 2017",
        link: "https://yourstory.com/2017/08/two-brothers-chandigarh-making-finvasia-one-stop-shop-various-funds",
        img: "Tajinder-Singh-and-Satyajeet-Singh-Co-founders-of-Finvasia.webp",
    },
    // {
    //   title:
    //     "Finvasia introduces Zero brokerage trading - The new age of stock trading arrives",
    //   description:
    //     "Finvasia, India's leading technology-driven brokerage firm, envisions creating a technologically driven 'ZERO BROKERAGE' financial ecosystem in...",
    //   date: "21 June 2017",
    //   link: "https://www.equitybulls.com/admin/news2006/news_det.asp?id=209534",
    //   img: "",
    // },
    // {
    //     title:
    //         "Are ‘truly free’ demat and trading accounts here in India with Finvasia?",
    //     description:
    //         "Finvasia, a technology-driven online broking start-up, announced that it has rolled out what it claimed was India’s first ‘truly’ free online demat account for investing in stocks and derivatives, including futures...",
    //     date: "20 JUN 2017",
    //     link: "https://ultra.news/s-k/31817/truly-free-demat-trading-accounts-india-finvasia",
    //     img: "",
    // },  
    {
        title: "Finvasia wins 2017 Benzinga Global Fintech Award",
        description:"Finvasia, India's first broker that offers commission free trading, has won the award for 'Best Trading Execution or Brokerage Platform'...",
        date: "19 May 2017",
        link: "https://www.business-standard.com/article/news-ani/finvasia-wins-2017-benzinga-global-fintech-award-117051900339_1.html",
        img: "",
    },
    {
        title:"Finvasia nominated for Benzinga Global Fintech Awards, NYC (USA)",
        description:"The finalists for 2017 Benzinga Global Fintech Awards have been announced and Finvasia has been nominated as a finalist for this premier...",
        date: "05 May 2017",
        link: "https://www.thehindubusinessline.com/business-wire/finvasia-nominated-for-benzinga-global-fintech-awards-nyc-usa/article22003021.ece",
        img: "",
    },
    {
        title: "Finvasia Offers Commission Free Trading Forever",
        description:"Finvasia is an India-based Fintech firm that hit the radar last year when it raised an undisclosed sum of investment capital...",
        date: "22 January 2017",
        link: "https://www.aninews.in/news/business/finvasia-with-symphony-launches-blitz-next-generation-algorithmic-trading-platform/",
        img: "",
    },                
    {
        title: "Finvasia with Symphony launches Blitz; next generation algorithmic trading platform",
        description:"Finvasia with Symphony launches Blitz; next generation algorithmic trading platform Finvasia with Symphony launches Blitz; next generation algorithmic trading platform...",
        date: "18 January 2017",
        link: "https://www.aninews.in/news/business/finvasia-with-symphony-launches-blitz-next-generation-algorithmic-trading-platform/",
        img: "",
    },
    {
        title: "Creating a commission free financial ecosystem in India",
        description:"Finvasia closed a funding deal for an undisclosed amount against a valuation of INR 1.5 Billion from some of the industry notable Venture Capitalists, where majority FDI stake is from Intrinsic Investment Limited...",
        date: "8 September  2016",
        link: "https://www.business-standard.com/article/news-ani/creating-a-commission-free-financial-ecosystem-in-india-116090801114_1.html",
        img: "shoonyanewpr1.jpg",
    },
    // {
    //   title:
    //     "Finvasia with Symphony Launches Blitz: The Next Generation Algorithmic Trading Platform",
    //   description:
    //     "Chandigarh, India:  Finvasia is delighted to announce the launch of Blitz Trader, a groundbreaking algorithmic trading & execution platform designed...",
    //   date: "18 January 2017",
    //   link: "https://www.businesswireindia.com/finvasia-with-symphony-launches-blitz-next-generation-algorithmic-trading-platform-51805.html",
    //   img: "",
    // },

    // {
    //   title:
    //     "FinTech Firm Finvasia Raises Investment at Rs 150Cr Valuation & More",
    //   description:
    //     "Fundingwire is your dose of notable investment announcements in the technology ecosystem. Firms which have recently...",
    //   date: "30 August 2016",
    //   link: "http://www.iamwire.com/2016/08/fintech-finvasia-funding/140948",
    //   img: "",
    // },
    {
        title: "Finvasia & 94.3 MYFM present – My Money Guru",
        description: "Finvasia in its continuing endeavor to promote financial literacy and improve investor awareness has joined hands with 94.3 MY FM...",
        date: "6 February 2014",
        link: "https://www.prlog.org/12278786-finvasia-943-myfm-present-my-money-guru.html",
        img: "",
    },              
    {
        title:"FINVASIA – A Truly Deep Discount Brokerage Company on the Block, Focusing on High Quality Client Service",
        description:"<strong>Sarvjeet Singh Virk, Managing Director at Finvasia, aims to strengthen Finvasia’s presence in the Indian retail brokerage market.</strong>...",
        date: "04 November 2013",
        link: "https://www.pressreleasepoint.com/finvasia-%E2%80%93-truly-deep-discount-brokerage-company-block-focusing-high-quality-client-service",
        img: "",
    },
    // {
    //   title:
    //     "FINVASIA – A Truly Deep Discount Brokerage Company on the Block, Focusing on High Quality Client Service",
    //   description:
    //     "Chandigarh, Punjab, India, April 11, 2013 - (PressReleasePoint) - Sarvjeet Singh Virk, Managing Director at Finvasia, aims to strengthen Finvasia’s presence in the Indian retail brokerage market...",
    //   date: "11  April 2013",
    //   link: "https://www.pressreleasepoint.com/finvasia-%E2%80%93-truly-deep-discount-brokerage-company-block-focusing-high-quality-client-service",
    //   img: "",
    // },
    {
        title: "सीआईआई चंडीगढ़ के चेयरमैन चुने गए विर्क, ग्रेवाल वाइस चेयरमैन बने",
        description: "फिनवएशिया ग्रुप ऑफ कंपनी के को-फाउंडर सर्वजीत सिंह विर्क को सीआईआई चंडीगढ़ का चेयरमैन बनाया गया है। ग्रेवाल आई इंस्टीट्यूट के सीईओ डॉ. एसपीएस ग्रेवाल को सीआईआई चंडीगढ़ काउंसिल का वाइस चेयरमैन नियुक्त किया गया है।...",
        date: "4 years ago",
        link: "https://www.bhaskar.com/union-territory/chandigarh/news/cii-elected-chandigarh-chairman-virk-grewal-became-vice-chairman-031608-4002158.html",
        img: "",
    },
]


//////////////////
// WEBPACK FOOTER
// ./static/website/json/new-annoucement.js
// module id = aNOP
// module chunks = 11 30